__webpack_require__.p = "https://beta.auth.ui.usm.prime-video.amazon.dev/";